import { styled } from '@mui/material/styles';
import BoltIcon from '@mui/icons-material/Bolt';

export const StyledListHeading = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export const StyledBoltIcon = styled(BoltIcon)(({ theme }) => {
  return {
    color: theme.palette.customSuccess.mainCustom,
  };
});
